import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useAuthenticationToken } from "src/authentication/hooks/useAuthenticationToken";
import { MessagePopup } from "src/shared/popups/MessagePopup";

export const SuspendedMerchantPopup = () => {
  const { menuDisplayLevel, isSuspended } = useAuthenticationToken();
  const [isPopupDismissed, setIsPopupDismissed] = useState(false);

  const handleDismiss = useCallback(() => {
    setIsPopupDismissed(true);
  }, []);

  if (menuDisplayLevel === 0 || !isSuspended || isPopupDismissed) {
    return null;
  }

  return (
    <MessagePopup
      header={<FormattedMessage id="authentication.suspended.header" />}
      abortPopup={handleDismiss}
      closePopup={handleDismiss}
    >
      <FormattedMessage
        id={
          menuDisplayLevel === 1
            ? "authentication.suspended.message.merchantGroup"
            : "authentication.suspended.message.merchant"
        }
      />
    </MessagePopup>
  );
};
